import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Flex } from "sprout-ui-primitives";
import { media } from "sprout-ui-theme";
import styled from "styled-components";
const StyledFlex = styled(Flex)`
  min-height: 36px;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;

  button {
    margin-top: 8px;
  }

  ${media.up("small")} {
    flex-direction: row;
    align-items: center;

    button {
      margin-top: 0;
      margin-left: 16px;
    }
  }
`;
const PageBannerWrapper = styled(Box)`
  padding: 10px 16px;
  border-radius: 30px;
  margin-bottom: 16px;

  ${media.up("medium", "pointer")} {
    padding: 10px 10px 40px;
    margin-bottom: -30px;
    border-radius: 30px 30px 0 0;
  }
`;
const PageBanner = (props)=>{
    const { children , bg  } = props;
    return /*#__PURE__*/ _jsx(PageBannerWrapper, {
        bg: bg,
        children: /*#__PURE__*/ _jsx(StyledFlex, {
            children: children
        })
    });
};
export default PageBanner;
